import {
  beforeSaveIncomplete,
  thenGetRows,
  defaultItem,
  defaultValues,
  save,
  askForDelete,
  deleteItem,
  getRows,
  setDefault,
  var_type,
  ask_for_toggle,
  toggle_item,
} from './CrudMethodsV1.js';
import { recursiveCopy } from '@/functions/general.js';
import config_name from './config_name.js';
export default {
  mixins:[config_name],
  props:{
    save_ok_close:{default:false},
    logic_delete_key:{default:'is_deleted'},
    no_filter:{default:false},
    merge_new_item:{default:null},
    flds:{default:()=>[]},
    beforeSaveIncomplete:{
      default: () => beforeSaveIncomplete,
    },
    st_key:{},
    logicDelete:{default:true},
    beforeSetRows:{},
    addItemAndSave:{default:false},
    canAdd:{default:true},
    canDelete:{default:true},
    canWrite:{default:true},
    canDetail:{default:true},
    afterSave:{},
    afterDeleting:{},
    after_toggle:{},
    beforeSelecting:{},
    afterSelecting:{},
    beforeSave:{},
    customGet:{},
    customGets:{},
    customPatch:{},
    customPost:{},
    dialogWriteWdith:{},
    /* name:{}, */
    onOpenDetail:{},
    preFilters:{},
    scheme:{},
    rowsFunction: {},
  },
  data() {
    return {
      show_write_btns:true,
      toggle_key:null,
      toggle_dialog: false,
      dialogDetail: false,
      dialogWrite: false,
      dialogCustom: false,
      deleteDialog: false,
      selectedItem: {},
      rows: [],
      defaultValues,
    };
  },
  computed: {
    schemeNotNull(){
      const ret = {};
      this.dev_log(this.scheme);
      if (this.scheme) {
        Object.keys(this.scheme)
          .filter(k => this.scheme[k].notNull)
          .forEach(k => ret[k] = this.scheme[k]);
      }
      return ret;
    },
    rq_filters() {
      if (!this.myRequestStatus) return null;
      return this.myRequestStatus.filter;
    },
    filters(){ return Object.assign({}, (this.preFilters || {}), this.defaultFilters, this.rq_filters) },
    defaultItem,
    patch_restore() { return this.requests.patch_restore[this.customPatch] || this.requests.patch_restore[this.name_single_computed] },
    patch() { return this.requests.patch[this.customPatch] || this.requests.patch[this.name_single_computed] },
    post() { return this.requests.post[this.customPost] || this.requests.post[this.name_all_computed] },
    gets() { return this.requests.gets[this.customGets] || this.requests.gets[this.name_all_computed/* this.name + '/all' */] },
    delete() { return this.requests.delete[this.name_single_computed] },
    get() { return this.requests.get[this.customGet] || this.requests.get[this.name_single_computed] },
    slot_key(){ return this.myRequestStatus.slot_key },
    computedRows() { return this.rowsFunction ?this.rowsFunction(this.rows):this.rows },
    requestStatus_status(){ return this.myRequestStatus.status},
  },
  watch:{
    'requestStatusRq'(v){ v.then && v.then(r => this.thenGetRows(r)) },
  },
  beforeDestroy(){ this.myRequestStatus.active = false },
  created(){
    if (this.gets_on_created) {
      if (!this.created_cache) {
        this.myRequestStatus.status = false;
        this.myRequestStatus.ticking = false;
      }
      if (!this.requestStatusRq.then) this.getRows();// si tiene, es pq los filtros se ejecutaron antes
      if (this.requestStatusRq.then && this.myRequestStatus.status) this.requestStatusRq.then(r => this.thenGetRows(r))
      else if (!this.pagination) this.getRows()
      else if (this.no_filter) this.getRows();
    }
    this.myRequestStatus.active = true;
  },
  methods: {
    var_type,
    setDefault,
    request(){
      this.resetRqStatus();
      return this.getRows();
    },
    getDefaultValue(d){ return typeof d === 'function' ?  d(): d },
    closeDialogWrite(){ this.dialogWrite = false },
    closeDialogCustom(){ this.dialogCustom = false },
    thenGetRows,
    save,
    async seletectItem(item,call) {
      if (this.get) {
        this.setProgress({show:true,message:'Cargando...'});
        this.get(item.id)
          .then(r => {
            this.setProgress({show:false});
            if (r.id) {
              this.setDefault(r);
              if (this.beforeSelecting) this.beforeSelecting(r);
              this.selectedItem = r;
              if (this.afterSelecting) this.afterSelecting(r);
            } else {
              this.closeDialogWrite();
              this.getError('customGet',r);
            };
            if (call) call();
          })
          .catch(e => this.closeDialogWrite() || this.getError(e));
      } else {
        if (this.beforeSelecting) this.beforeSelecting(item);
        this.selectedItem = recursiveCopy(item);//{...item};
        if (this.afterSelecting) this.afterSelecting(item);
        if (call) call();
      }
    },
    writeItem(item) { this.seletectItem(item, ()=>this.dialogWrite = true) },
    itemDetail(item){
      this.seletectItem(item);
      this.dialogDetail = true;
      if(this.onOpenDetail) this.onOpenDetail(item, this.rows)
    },
    resetRqStatus(rq=this.myRequestStatus){
      rq.status = 2;
      rq.ticking = false;
    },
    newItem(){
      this.selectedItem = {...this.defaultItem};
      if (this.merge_new_item) Object.assign(this.selectedItem,this.merge_new_item);
      this.dialogWrite = true;
      if (this.afterSelecting) this.afterSelecting(this.selectedItem);
      if(this.addItemAndSave) this.save();      
    },
    check_and_save(){
      if (!this.beforeSaveIncomplete()) return false;
      if(this.save_ok_close){
        this.show_write_btns = false;
        this.save().then(r=>r.id && this.closeDialogWrite()).then(r=>this.show_write_btns = true)
      }else this.closeDialogWrite() || this.save();
    },
    askForDelete,
    deleteItem,
    getRows,
    ask_for_toggle,
    toggle_item,
  },
};
